// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2M5R-","header":"Messages_header__2UzlG"};